import React, { Component } from 'react';

class ListaEstudiantes extends Component {
    state = {  }
    render() {
        let { est, num } = this.props;

        const styles = {
            padding: 5, fontSize: 10
        }

        let nombre2 = "";
        let apellido2 = "";
        (est.nombre_2 === null) ? nombre2 = "" : nombre2 = est.nombre_2;
        (est.apellido_2 === null) ? apellido2 = "" : apellido2 = est.apellido_2;

        let nombres = `${est.nombre_1} ${nombre2}`;
        let apellidos = `${est.apellido_1} ${apellido2}`;

        return (
            <React.Fragment>
                <tr height={40}>
                    <td style={styles} align="center"><strong>{num}</strong></td>
                    <td style={styles}>{`${est.nacionalidad} ${est.ci}`}</td>
                    <td style={styles}>{apellidos}</td>
                    <td style={styles}>{nombres}</td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default ListaEstudiantes;


// WEBPACK FOOTER //
// ./src/views/Estudiantes/ListaEstudiantes.jsx